
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 501.481 501.481"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M498.281 468.34L270.014 11.807C265.747 4.34 259.347.074 250.814.074s-16 4.267-19.2 11.733L2.281 471.541c-3.2 6.4-3.2 13.867 1.067 20.267 4.267 5.333 10.667 9.6 18.133 9.6h458.667c11.733 0 21.333-9.6 21.333-21.333-.001-4.268-1.067-8.534-3.2-11.735zm-443.734-8.533L250.814 67.274l195.2 392.533H54.547z"}}),_c('path',{attrs:{"d":"M250.814 182.474c-11.733 0-21.333 9.6-21.333 21.333V314.74c0 11.733 9.6 21.333 21.333 21.333s20.267-9.6 21.333-21.333V203.807c0-11.733-9.6-21.333-21.333-21.333zM250.814 369.141c-11.733 0-21.333 9.6-21.333 21.333v7.467c0 11.733 9.6 21.333 21.333 21.333s20.267-9.6 21.333-21.333v-7.467c0-11.733-9.6-21.333-21.333-21.333z"}})])
          )
        }
      }
    